import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ThemeProvider } from '@material-ui/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import theme from 'theme'
import store, { history } from './redux/store'
import './index.css'
import AppGlobal from './AppGlobal'
import * as serviceWorker from './serviceWorker'
import { IntlProviderWrapper } from './context/LocaleContext'
import { SnackbarProvider } from 'notistack'
import Snackbar from 'containers/Snackbar'
import { SNACKBAR_DURATION } from './constants'

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <IntlProviderWrapper>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            content={(key, message) => <Snackbar id={key} message={message} />}
            autoHideDuration={SNACKBAR_DURATION}
          >
            <AppGlobal />
          </SnackbarProvider>
        </IntlProviderWrapper>
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
